import styled from 'styled-components';

export const Container = styled.section`
  font-family: 'Work Sans', Arial, Helvetica, sans-serif;

  & > header {
    padding: 1.5rem;

    & > div {
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: ${({ theme }) => theme.breakpoints.laptopL};
      }
    }

    & > .title {
      font-weight: 700;
      margin-bottom: 1rem;
      font-size: 1.625rem;
    }

    & > span {
      font-size: 1rem;
      letter-spacing: 0.1px;
      & > h1 {
        margin-bottom: 1rem;
      }
    }
  }

  & .cards {
    width: 100%;
    padding: 1.5rem 0;
    background-color: #efefef;

    & > .subtitle-cards {
      margin: 1.5rem;
      margin-top: 0;
    }

    & .cards-container {
      display: flex;
      flex-wrap: wrap;
      row-gap: 1rem;
      column-gap: 1.5rem;
      width: 97%;
      margin: 1rem 1.5rem 1.5rem 1.5rem;

      & .cards-container:last-child {
        column-gap: 0;
      }

      & > .card {
        width: 100%;
        min-height: 15rem;
        max-width: 16.875rem;

        & > .hefesto-card {
          height: 100%;

          & > .hefesto-card-text-buttons {
            display: flex;
            flex-direction: column;
            height: 100%;

            & > .hefesto-title {
              margin-right: 0.5rem;
              margin-bottom: 0.313rem;
              & > h4 {
                margin: 0px;
              }
            }
            & > .hefesto-card-text-buttons__description {
              flex-grow: 1;
              margin-top: 0rem;
              margin-right: 0.5rem;
            }
            & > .hefesto-card-text-buttons__actions {
              & > .hefesto-button {
                padding-inline: 0px;
              }
            }
          }
        }
      }

      p {
        min-height: 75px;
      }

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: ${({ theme }) => theme.breakpoints.laptopL};
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-wrap: nowrap;
        column-gap: 1.5rem;

        & > .card {
          width: 50%;
        }
      }
    }
  }
`;
